function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Add to My Collection");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "fave-sel",
  fill: "#3F3F3D",
  fillRule: "nonzero",
  stroke: "#3F3F3D"
}, React.createElement("path", {
  d: "M10,17.38 C10,17.38 15.75,12.84 18.11,9.38 C20.47,5.92 19.42,1.38 15.81,0.67 C12.2,-0.04 10,3.51 10,3.51 C10,3.51 7.8,-2.22044605e-16 4.19,0.71 C0.58,1.42 -0.47,6 1.89,9.42 C4.25,12.84 10,17.38 10,17.38 Z",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    version: 1.1
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/fave-sel.8a2cc736.svg";
export { SvgComponent as ReactComponent };